// extracted by mini-css-extract-plugin
export var adjacentSlide = "_ps-9";
export var arrowButtonContainer = "_ps-5";
export var arrowButtonIcon = "_ps-6";
export var carouselArrowButton = "_ps-2";
export var carouselElementContainer = "_ps-1";
export var currentSlide = "_ps-8";
export var left = "_ps-3";
export var otherSlide = "_ps-a";
export var productCarouselContainer = "_ps-0";
export var right = "_ps-4";
export var sliderOverflow = "_ps-7";